import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SideNav} from "../../repository/entity/base.entity";
import {Router} from '@angular/router';
import {LoginResponse} from "../../../auth/repository/entity/auth.entity";

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent {
  @Input() sideNav: SideNav[]
  @Input() user: LoginResponse
  @Output() clickMenu = new EventEmitter;

  constructor(
    private router: Router
  ) {

  }

  onClickLogout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('company_code');
    this.router.navigate(['auth/login']);
  }
}
